const apiurl = 'https://eprof-production-6g7zxvibga-uc.a.run.app';

export default apiurl;